import { render } from "./App.vue?vue&type=template&id=c8940cf0"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script